class Cookie {
  // Get the value of a cookie
  static get(name) {
    if (document.cookie) {
      const value = `; ${document.cookie}`;
      const parts = value?.split(`; ${name}=`);
      if (parts.length === 2) {
        return parts.pop()?.split(";")?.shift();
      }
    }
  }

  // Set the value of a cookie
  static set(name, value, days, domain = "") {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value};${expires};path=/${
      domain ? `;domain=${domain}` : ""
    }`;
  }

  // Delete a cookie
  static delete(name) {
    this.set(name, "", -1);
  }

  static getOrSetSession() {
    if (!this.get("session")) {
      this.set("session", Math.random().toString(36).substring(2, 15, 7), 7);
    } else {
      return this.get("session");
    }
  }
}

export default Cookie;
